import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import { ticketTypeRequest } from "../../companyRequestContants/companyRequestContants";
import useExportDocxFile from "../../request-vehicle/TemplateDocx/useExportDocxFile";
import { useState } from "react";
import { TableHelpers } from "../../../../../helper/TableHelper";
import { requestStatus } from "../../../../../constants";

export const useBusinessTicketsColumn = () => {
  const [currentItem, setCurrentItem] = useState<any>();
  const { exportForm } = useExportDocxFile({ item: currentItem, docType: 2 });

  const handleSubmit = (item: any, isReroute: boolean = false) => {
    exportForm(item, isReroute);
  };

  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "100px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "120px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),
    },
    {
      title: "Yêu cầu",
      dataIndex: "eTicketType",
      key: "eTicketType",
      render: (text: string) => (
        <span className={text !== "refund" ? "flag success" : "flag danger"}>
          {text && (ticketTypeRequest.find((o) => o.value === text)?.label || "")}
        </span>
      ),
      width: "180px",
      filters: [
        { text: "Cấp vé và giấy đi đường", value: "full" },
        { text: "Chỉ cấp vé", value: "ticket" },
        { text: "Chỉ cấp giấy đi đường", value: "passport" },
        { text: "Hoàn vé", value: "refund" },
      ],
      onFilter: (status: any, record) => record.eTicketType.indexOf(status) === 0,
    },
    {
      title: "Mô tả",
      dataIndex: "eDescription",
      key: "eDescription",
      ...TableHelpers.searchInput({ dataIndex: "eDescription" }),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      width: "120px",
      render: (text: string) => <ApprovalStatus status={text} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted,
        },
        {
          text: "Đã thực hiện",
          value: requestStatus.inProgress,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed,
        },
        {
          text: "Đã bị từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (status: any, record) => record.eRequestStatus.indexOf(status) === 0,
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <>
          <Button
            title={"Xuất phiếu yêu cầu xuất vé"}
            className="mr-2"
            variant="outline-info"
            onClick={(e: any) => {
              e.stopPropagation();
              setCurrentItem(record);
              handleSubmit(record);
            }}
          >
            <FontFa name="faFileWord" size={"xs"} />
          </Button>
          <Button
            title={"Xuất phiếu yêu cầu hoàn vé"}
            className=""
            variant="outline-warning"
            onClick={(e: any) => {
              e.stopPropagation();
              setCurrentItem(record);
              handleSubmit(record, true);
            }}
          >
            <FontFa name="faFileWord" size={"xs"} />
          </Button>
        </>
      ),
    },
  ];
  return { columns };
};
